import { useState } from "react";
import { MapPin } from "lucide-react";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { api } from "../client";
import { Panel } from "../ui";

const RADII = [15, 30, 50, 75, 100];
const ACTIVITY = [["all", "All active users"], ["48h", "Active within 48 hrs"], ["7d", "Active within 7 days"], ["30d", "Active within 30 days"]];

export default function ZipReach() {
  const [zip, setZip] = useState("");
  const [radius, setRadius] = useState("30");
  const [activity, setActivity] = useState("all");
  const [res, setRes] = useState(null);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const run = async (e) => {
    e.preventDefault();
    if (!/^\d{5}$/.test(zip)) return setErr("Enter a 5-digit zip code.");
    setBusy(true); setErr("");
    try { setRes(await api(`/staff/zip-reach?zip=${zip}&radius=${radius}&activity=${activity}`)); }
    catch (e2) { setErr(e2.message); setRes(null); } finally { setBusy(false); }
  };
  return (
    <Panel className="mb-8 p-5 s-rise" data-testid="zip-reach">
      <p className="s-mono mb-3 text-[11px] uppercase tracking-[0.2em] text-[var(--s-accent)]">Discovery reach by zip code</p>
      <form onSubmit={run} className="flex flex-wrap items-center gap-2">
        <Input value={zip} onChange={(e) => setZip(e.target.value.replace(/\D/g, "").slice(0, 5))} placeholder="Zip code" className="s-input w-32" data-testid="zip-reach-input" />
        <Select value={radius} onValueChange={setRadius}>
          <SelectTrigger className="s-input w-32" data-testid="zip-reach-radius"><SelectValue /></SelectTrigger>
          <SelectContent>{RADII.map((r) => <SelectItem key={r} value={String(r)} data-testid={`zip-radius-${r}`}>{r} miles</SelectItem>)}</SelectContent>
        </Select>
        <Select value={activity} onValueChange={setActivity}>
          <SelectTrigger className="s-input w-52" data-testid="zip-reach-activity"><SelectValue /></SelectTrigger>
          <SelectContent>{ACTIVITY.map(([v, l]) => <SelectItem key={v} value={v} data-testid={`zip-activity-${v}`}>{l}</SelectItem>)}</SelectContent>
        </Select>
        <Button type="submit" disabled={busy} className="s-btn" data-testid="zip-reach-submit"><MapPin size={14} className="mr-1" />{busy ? "Counting…" : "Count users"}</Button>
      </form>
      {err && <p className="mt-3 text-sm text-red-300" data-testid="zip-reach-error">{err}</p>}
      {res && (
        <div className="mt-4 flex flex-wrap items-end gap-8" data-testid="zip-reach-result">
          <div>
            <p className="s-display text-4xl" data-testid="zip-reach-count">{res.in_range}</p>
            <p className="text-xs text-[var(--s-dim)]">users within {res.radius} mi of {res.zip} · {ACTIVITY.find(([v]) => v === res.activity)?.[1]}</p>
          </div>
          <p className="max-w-md text-xs text-[var(--s-dim)]">{res.place}<br />{res.without_location} users in the database (any area) have no saved location and can't be counted · {res.excluded_deleted} deleted or deletion-requested accounts excluded</p>
        </div>
      )}
    </Panel>
  );
}
